import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { useSubcategoryStore } from "../../../hooks/useSubcategoryStore";

const columns = [
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align:'center' },
];

export const ShowSubcategoriesModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, categorySelected, clearState } = props;

    const { getSubcategoriesByCategory } = useSubcategoryStore();

    const [loading, setLoading] = useState(false);
    const [subcategories, setSubcategories] = useState<any>([]);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getSubcategoriesByCategoryApi()
    },[])

    const getSubcategoriesByCategoryApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getSubcategoriesByCategory(search, categorySelected.id);
            if(!response){
                setSubcategories([]);
                setLoading(false);
                return false;
            }else{
                setSubcategories(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getSubcategoriesByCategoryApi(term)}, 1000)
        )
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md">
            <ModalHeader
                text={'Subcategorias'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Grid container sx={{padding:'20px'}}>
                    <Grid item container xs={12} spacing={2}>
                        <CustomTable 
                            disabled_title
                            columns={columns} 
                            loading={loading}
                            rows={subcategories || []}
                            onRowClick={() => {}}
                            onSearch={onSearch}
                            RowsPerPage={5}
                            dense
                        />
                    </Grid>
                </Grid>
            </ModalBody>
        </Modal>
    )
}